<template>
	<InputAmount
		:header-title="t('newPayment.sum')"
		v-model="amount"
		:currency="viewPaymentController.currency.value.name"
		@update:focused="handleFocusInputAmount"
		@blur="handleBlurInputAmount"
    :disabled="isSubmitLoading"
	>
		<template #header-end>
			<InputAmountRange
				:ranges="minMaxRangesAmountByFlow"
				:currency="viewPaymentController.currency.value.name"
				:is-loading="isAgentsRangesLoading"
				:is-error="textMaxMinError"
			/>
		</template>
		<template #content>
			<Transition name="fade" mode="out-in">
				<InputAmountButton
					v-if="isShowMinMaxRangeByFlow"
					@click="handleClickMaxAmount"
					text="MAX"
				/>
			</Transition>
		</template>
	</InputAmount>
</template>

<script setup lang="ts">
import InputAmountButton from "@components/ui/input-amount/InputAmountButton.vue";
import InputAmountRange from "@components/ui/input-amount/InputAmountRange.vue";
import InputAmount from "@components/ui/input-amount/InputAmount.vue";
import {getDevice} from "framework7/shared/get-device";
import {computed} from "vue";
import NewPaymentController from "@/views/payment-create-config/NewPaymentController";
import {useI18n} from "vue-i18n";

const { t } = useI18n({useScope: 'global'});
const viewPaymentController = NewPaymentController.getInstance();

const {
	amount,
	isAgentsRangesLoading,
	minMaxRangesAmountByFlow,
	inputAmountFocused,
	textMaxMinError,
  isSubmitLoading
} = viewPaymentController;

const isShowMinMaxRangeByFlow = computed(() => {
	const { min, max } = minMaxRangesAmountByFlow.value;
	return !(!min || !max);
});

const handleFocusInputAmount = (value: boolean) => {
	textMaxMinError.value = false;
	inputAmountFocused.value = value;
}

const handleBlurInputAmount = () => {
	const timeout = getDevice().cordova ? 314 : 0;

	setTimeout(() => {
		inputAmountFocused.value = false;
	}, timeout);

	if (amount.value === 0) {
		amount.value = viewPaymentController.calculateStartAmountValue();
	}
}

const handleClickMaxAmount = () => {
	viewPaymentController.setMaxAmount();
}
</script>
